<template>
  <div>
    <To :to="data.to" @updateTo="data.to = $event"></To>
    <FormInput label="Question" :value="data.question" hint="" @update="data.question = $event"></FormInput>
    <Options :options="data.options" @updateOptions="data.options = $event"></Options>
    <div class="input-group mb-3">
      <div class="input-group-prepend">
        <span class="input-group-text">Answer</span>
      </div>
      <select v-model="data.correct_option_id" class="form-control">
          <option v-for="(answer, index) in data.options" :value="index | string" :key="index">{{answer}}</option>
      </select>
    </div>
    <h6>Settings</h6>
    <CheckBox label="Anonymous Voting" :value="data.is_anonymous" @change="data.is_anonymous = $event"></CheckBox>
    <ReplyMarkup :reply_markup="data.reply_markup" :actions="actions" @changeReplyMarkup="data.reply_markup = $event"></ReplyMarkup>
  </div>
</template>


<script>
import ReplyMarkup from '@/components/tasks/fields/ReplyMarkup.vue'
import To from '@/components/tasks/fields/To.vue'
import FormInput from '@/components/tasks/fields/FormInput.vue'
import Options from '@/components/tasks/fields/Options.vue'
import CheckBox from '@/components/tasks/fields/CheckBox.vue'





export default {
  name: 'SendQuiz',
  components:{
    ReplyMarkup,
    To,
    FormInput,
    Options,
    CheckBox
  },
  props: {
    data: Object,
    actions: Object
  },
  methods:{
  },
  filters: {
    string: function (value) {
      if (value!=0 && !value) return ''
      value = value.toString()
      return value
    }
  }


}
</script>
